import React from 'react';
import { IonButton, IonInput, IonItem, IonList } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import {uiInputMode} from "../../utils/ui";

type ResetPwFormProps = {
  isValid: boolean;
  email: string;
  proceed: () => void;
  setEmail: (s: string) => void;
};

export default function ResetPwForm({
  isValid,
  email,
  proceed,
  setEmail,
}: ResetPwFormProps) {
  const [t] = useTranslation('global');

  const useTestData = () => {
    setEmail('john@doe.com');
  };

  return (
    <>
      <h1 className="h1">{t('resetpw.subtitle')}</h1>
      <p className="pt-2 pb-2 instructions ion-text-center">
        {t('resetpw.forminfo')}
      </p>
      <IonList inset={false}>
        <IonItem lines="none" className="ion-no-padding ion-pt-2 ion-pb-2">
          <IonInput
            value={email}
            mode={uiInputMode()}
            aria-label={t('resetpw.email')!}
            placeholder={t('resetpw.email')!}
            onIonInput={(e) => setEmail(e.detail.value!)}
            onDoubleClick={() => useTestData()}
            type="email"
            fill="outline"
          ></IonInput>
        </IonItem>
      </IonList>

      <div className="pt-4 ion-text-center">
        <IonButton
          className={
            'btn-default btn-wide-80 ' + (isValid ? '' : 'btn-disabled')
          }
          onClick={() => proceed()}
        >
          {t('resetpw.continue')}
        </IonButton>
      </div>
    </>
  );
}
